import { render, staticRenderFns } from "./NotificationsDropdown.vue?vue&type=template&id=ec76d6cc&scoped=true&"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=ts&"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsDropdown.vue?vue&type=style&index=0&id=ec76d6cc&lang=scss&scoped=true&"
import style1 from "./NotificationsDropdown.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec76d6cc",
  null
  
)

export default component.exports